import { IUserOutputDto } from '@quadminds/shared/auth-system';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { usersApi } from '../services/users.service';

/**
 * Hook para obtener los datos de un usuario específico dentro de una organización.
 *
 * @param organizationId - ID de la organización.
 * @param userId - ID del usuario.
 * @returns Los datos del usuario y el estado de la consulta.
 */
export const useOrganizationUserById = (
    organizationId: string,
    userId: string,
): UseQueryResult<IUserOutputDto, Error> => {
    return useQuery<IUserOutputDto, Error>({
        queryKey: ['organizationUserById', organizationId, userId], // Clave única para la consulta
        queryFn: async () => {
            if (!organizationId || !userId) {
                throw new Error('Organization ID y User ID son requeridos para obtener los datos del usuario');
            }

            const response = await usersApi.getOrganizationUserById(organizationId, userId);
            return response.data;
        },
        enabled: !!organizationId && !!userId, // Ejecutar la consulta solo si ambos parámetros están presentes
    });
};
